import { render, staticRenderFns } from "./Step6Payment.vue?vue&type=template&id=204a74be&scoped=true"
import script from "./Step6Payment.vue?vue&type=script&lang=js"
export * from "./Step6Payment.vue?vue&type=script&lang=js"
import style0 from "./Step6Payment.vue?vue&type=style&index=0&id=204a74be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a74be",
  null
  
)

export default component.exports